export const FeatureFlags = {
  SEO_ENABLED_STATUS: {
    flagName: "isDFFSeoEnabled",
    defaultValue: false,
  },
  EASY_CATALOG_ENABLED_STATUS: {
    flagName: "isEasyCatalogEnabled",
    defaultValue: false,
  },
  SIZE_CHART_ENABLED_STATUS: {
    flagName: "isSizeChartEnabled",
    defaultValue: false,
  },
  BULK_ADD_TO_COLLECTION_ENABLED_STATUS: {
    flagName: "isBulkAddToCollectionEnabled",
    defaultValue: false,
  },
  UAM_ENABLED_STATUS: {
    flagName: "isUAMEnabledForDFF",
    defaultValue: false,
  },
  CUSTOMER_SEGMENTS_ENABLED_STATUS: {
    flagName: "isCustomerSegmentsEnabled",
    defaultValue: false,
  },
  MA_ENABLED_STATUS: {
    flagName: "isMarketingAutomationEnabledInDFF",
    defaultValue: false,
  },
  GOOGLE_ADS_CATALOG_SYNC_STATUS: {
    flagName: "isGoogleAdsCatalogSyncEnabled",
    defaultValue: false,
  },
  REVIEWS_ENABLED_STATUS: {
    flagName: "isReviewsEnabled",
    defaultValue: false,
  },
  GOOGLE_REVIEWS_ENABLED_STATUS: {
    flagName: "isGoogleReviewsEnabled",
    defaultValue: false,
  },
  GST_SELLER_STATUS: {
    flagName: "isGSTInvoiceEnabled",
    defaultValue: false,
  },
  META_ENABLED_STATUS: {
    flagName: "isMETAEnabled",
    defaultValue: false,
  },
  ANALYTICS_ENABLED_STATUS: {
    flagName: "isAnalyticsEnabled",
    defaultValue: false,
  },
  CONNECTIONS_ENABLED_STATUS:{
    flagName: "isConnectionsEnabledInDFF",
    defaultValue: false,
  },
  CLM_AUTOMATION_ENABLED_STATUS: {
    flagName: "isClmAutomationEnabledInDFF",
    defaultValue: false,
  },
  CLM_BROADCAST_ENABLED_STATUS: {
    flagName: "isClmBroadcastEnabledInDFF",
    defaultValue: false,
  },
  CLM_ORDER_ALERT_ENABLED_STATUS: {
    flagName: "isClmOrderAlertEnabledInDFF",
    defaultValue: false,
  },
  HOME_PAGE_KPI_BAR_ENABLED_STATUS: {
    flagName: "isHomePageKPIEnabledInDFF",
    defaultValue: false,
  },
};
